import { render, staticRenderFns } from "./RepxList.vue?vue&type=template&id=55c638c3"
import script from "./RepxList.vue?vue&type=script&lang=js"
export * from "./RepxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c638c3')) {
      api.createRecord('55c638c3', component.options)
    } else {
      api.reload('55c638c3', component.options)
    }
    module.hot.accept("./RepxList.vue?vue&type=template&id=55c638c3", function () {
      api.rerender('55c638c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/repx/RepxList.vue"
export default component.exports